import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { MODULES } from '../../lib/modules.js';
import { canSeeSubscreen, useRole } from '../../lib/role.tsx';

// «Скоро»-табы по дизайну mp-admin-preprod-2026-05-17/reception.jsx:
// курьеры — stub без реальных данных; БЗ — заглушка с redirect на /m/kb
// (сама БЗ — ComingSoonLanding). После запуска (понедельник 2026-05-25)
// флаги снимаем по мере готовности модулей.
const SOON_TABS = new Set<string>(['couriers', 'kb-shortcut']);

export function ReceptionLanding() {
  const role = useRole();
  const navigate = useNavigate();

  const receptionMod = MODULES.find((m) => m.slug === 'reception')!;
  const visibleTabs = receptionMod.subscreens!.filter((sub) => canSeeSubscreen(role, sub));

  return (
    <div className="flex flex-col h-full">
      <nav className="flex border-b border-gray-200 bg-white">
        {visibleTabs.map((sub) => {
          const soon = SOON_TABS.has(sub.slug);
          const soonBadge = soon ? (
            <span
              className="ml-1.5 inline-flex items-center justify-center text-[10px] font-bold uppercase tracking-wider text-gray-500 bg-gray-100 px-1.5 py-0.5 rounded"
              data-testid={`reception-tab-${sub.slug}-soon`}
            >
              Скоро
            </span>
          ) : null;

          // «Скоро»-табы недоступны: рендерим как неактивный span (без перехода),
          // чтобы бейдж «Скоро» не противоречил кликабельности.
          if (soon) {
            return (
              <span
                key={sub.id}
                data-testid={`reception-tab-${sub.slug}`}
                data-soon="true"
                aria-disabled="true"
                title="Скоро"
                className="px-4 py-2 text-sm font-medium text-gray-400 border-b-2 border-transparent inline-flex items-center cursor-not-allowed select-none"
              >
                {sub.label}
                {soonBadge}
              </span>
            );
          }

          if (sub.id === 'kb-shortcut') {
            return (
              <button
                key={sub.id}
                data-testid={`reception-tab-${sub.slug}`}
                data-soon={soon || undefined}
                onClick={() => navigate('/m/kb')}
                className="px-4 py-2 text-sm font-medium text-gray-600 hover:text-mnp-stamp border-b-2 border-transparent hover:border-mnp-stamp transition-colors inline-flex items-center"
              >
                {sub.label}
                {soonBadge}
              </button>
            );
          }
          return (
            <NavLink
              key={sub.id}
              to={`/m/reception/${sub.slug}`}
              data-testid={`reception-tab-${sub.slug}`}
              data-soon={soon || undefined}
              className={({ isActive }) =>
                `relative px-4 py-2 text-sm font-medium border-b-2 transition-colors inline-flex items-center ${
                  isActive
                    ? 'text-mnp-stamp border-mnp-stamp'
                    : 'text-gray-600 border-transparent hover:text-mnp-stamp hover:border-mnp-stamp'
                }`
              }
            >
              {sub.label}
              {soonBadge}
            </NavLink>
          );
        })}
      </nav>
      <div className="flex-1 overflow-auto">
        <Outlet />
      </div>
    </div>
  );
}
